import React, { useEffect, useState, useRef } from 'react';
import { motion, useSpring } from 'framer-motion';
import { useColors } from '../context/ColorContext';
import { useLocation } from 'react-router-dom';
const InteractiveBackground = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const getCategoryColors = () => {
    if (currentPath.includes('/video')) {
      return {
        primary: 'rgba(99, 102, 241, 0.05)',
        secondary: 'rgba(79, 70, 229, 0.03)'
      };
    } else if (currentPath.includes('/photo')) {
      return {
        primary: 'rgba(244, 63, 94, 0.05)',
        secondary: 'rgba(225, 29, 72, 0.03)'
      };
    } else if (currentPath.includes('/motion')) {
      return {
        primary: 'rgba(20, 184, 166, 0.05)',
        secondary: 'rgba(13, 148, 136, 0.03)'
      };
    }
    return {
      primary: 'rgba(229, 231, 235, 0.05)',
      secondary: 'rgba(209, 213, 219, 0.03)'
    };
  };
  const colors = getCategoryColors();
  const {
    colors: contextColors
  } = useColors();
  const mouseRef = useRef({
    x: 0,
    y: 0
  });
  const velocityRef = useRef({
    x: 0,
    y: 0
  });
  const blob1X = useSpring(0, {
    stiffness: 100,
    damping: 30,
    mass: 1
  });
  const blob1Y = useSpring(0, {
    stiffness: 100,
    damping: 30,
    mass: 1
  });
  const blob2X = useSpring(0, {
    stiffness: 85,
    damping: 35,
    mass: 1.2
  });
  const blob2Y = useSpring(0, {
    stiffness: 85,
    damping: 35,
    mass: 1.2
  });
  const blob3X = useSpring(0, {
    stiffness: 70,
    damping: 40,
    mass: 1.4
  });
  const blob3Y = useSpring(0, {
    stiffness: 70,
    damping: 40,
    mass: 1.4
  });
  useEffect(() => {
    let rafId: number;
    let lastMouseX = 0;
    let lastMouseY = 0;
    const handleMouseMove = (e: MouseEvent) => {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const normX = (e.clientX - windowWidth / 2) / windowWidth;
      const normY = (e.clientY - windowHeight / 2) / windowHeight;
      const velocity = {
        x: (normX - lastMouseX) * 50,
        y: (normY - lastMouseY) * 50
      };
      lastMouseX = normX;
      lastMouseY = normY;
      mouseRef.current = {
        x: normX,
        y: normY
      };
      velocityRef.current = velocity;
      if (!rafId) {
        rafId = requestAnimationFrame(updateBlobs);
      }
    };
    const updateBlobs = () => {
      rafId = 0;
      const mouse = mouseRef.current;
      const velocity = velocityRef.current;
      const baseX1 = mouse.x * 300 + velocity.x;
      const baseY1 = mouse.y * 300 + velocity.y;
      const baseX2 = -mouse.x * 400 + velocity.x;
      const baseY2 = mouse.y * 200 + velocity.y;
      const baseX3 = mouse.x * 350 + velocity.x;
      const baseY3 = -mouse.y * 250 + velocity.y;
      blob1X.set(baseX1);
      blob1Y.set(baseY1);
      blob2X.set(baseX2);
      blob2Y.set(baseY2);
      blob3X.set(baseX3);
      blob3Y.set(baseY3);
    };
    window.addEventListener('mousemove', handleMouseMove, {
      passive: true
    });
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);
  return <div className="absolute inset-0 overflow-hidden" data-id="element-116">
      <motion.div className="absolute h-[45rem] w-[45rem] rounded-[12rem] mix-blend-multiply filter blur-2xl will-change-transform opacity-60" style={{
      backgroundColor: colors.primary,
      x: blob1X,
      y: blob1Y,
      transition: 'background-color 1s ease'
    }} data-id="element-117" />
      <motion.div className="absolute right-0 h-[40rem] w-[40rem] rounded-[12rem] mix-blend-multiply filter blur-2xl will-change-transform opacity-60" style={{
      backgroundColor: colors.secondary,
      x: blob2X,
      y: blob2Y,
      transition: 'background-color 1s ease'
    }} data-id="element-118" />
      <motion.div className="absolute left-60 h-[35rem] w-[35rem] rounded-[12rem] mix-blend-multiply filter blur-2xl will-change-transform opacity-60" style={{
      backgroundColor: contextColors.primary,
      x: blob3X,
      y: blob3Y,
      transition: 'background-color 1s ease'
    }} data-id="element-119" />
    </div>;
};
export default InteractiveBackground;